import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateChannelEntity } from '../../domain/entities/CreateUpdateChannel'
import type { ChannelTranslationRequestAdmin } from '@/backend/market'
import { ChannelStatus, ChannelType } from '@/backend/market'

export class CreateUpdateChannelModel extends CreateUpdateChannelEntity {
  type: ChannelType = ChannelType.SINGULAR
  status: ChannelStatus = ChannelStatus.ACTIVE
  translations: Array<ChannelTranslationRequestAdmin> = []
  profileImage!: { bytes: string; fileName: string }
  coverImage?: { bytes: string; fileName: string }

  constructor(dataDto: CreateUpdateChannelEntity) {
    super()
    mapEntityProperties<CreateUpdateChannelModel>(this, dataDto, {
      exclude: ['imageData', 'coverImageData', 'regions'],
      map: {
        profileImage: dataDto.imageData,
        coverImage: dataDto.coverImageData,
        activeRegions: dataDto.regions?.map((region) => ({
          regionId: region.region?.id,
          coverImages: region.coverImages?.map((coverImage) => ({
            coverImage: coverImage.coverImage,
            serviceCoverImage: coverImage.serviceCoverImage,
            language: coverImage.language
          }))
        }))
      }
    })
  }
}
